import App from './app';
import 'jquery.maskedinput/src/jquery.maskedinput';
import '../vendor/jquery-ui-custom';
import sendForm from './forms/ajax-send';
import formSuccess from './forms/form-success';
import formError from './forms/form-error';
import uiSelect from './jquery-plugins/ui-select';
import autosize from 'autosize';

(($) => {
  function initForms(html) {
    if (!html) return false;
    const $context = $(html);
    autosize($context.find('.js-textarea'));
    $context.find('.js-input-phone').mask('+7(999) 999-99-99');
    $context.find('.js-select').each(function () {
      uiSelect($(this));
    });
    return $context;
  }
  initForms($('body'));
  App.stream.add(initForms);
})(jQuery);

$(document)
  .on('submit', 'form.js-ajax-form', (event) => {
    sendForm(event, formSuccess, formError);
  });

$('.js-form-field').each(function () {
  const self = $(this);
  const clear = self.find('[data-clear]');
  const input = self.find('input, textarea');
  if (!input.length) return false;
  function check() {
    if ($.trim(input.val()).length > 0) {
      clear.show(0);
      input.addClass('is-changed');
    } else {
      clear.hide(0);
      input.removeClass('is-changed');
    }
  }
  clear.on('click', (event) => {
    event.preventDefault();
    input.val('').focus();
    clear.hide(0);
  });
  check();
  input.on('change', check);
});

$('.js-form-password').each(function () {
  const self = $(this);
  const btn = self.find('[data-password]');
  const input = self.find('[type="password"]');
  if (!input.length) return false;
  btn.on('click', (event) => {
    event.preventDefault();
    if (btn.is('.is-active')) {
      input.attr('type', 'password');
      btn.removeClass('is-active').attr('title', 'Показать');
    } else {
      const val = input.val();
      input.attr('type', 'text').val('').focus().val(val);
      btn.addClass('is-active').attr('title', 'Скрыть');
    }
  });
});
